import FadeIn from "react-fade-in";

export default function Privacy() {
  return (
    <FadeIn delay={100}>
      <div className="jumbotron">
        <h2>Lorem Ipsum Dolor</h2>
        <p>Consectetur Adipisci Elit</p>
        <p>Earum facere quibusdam! Ipsam laboriosam.</p>
        <h3>Lumque corrupti accusantium corporis quo neque</h3>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Tenetur
          labore quos amet ab exercitationem voluptas omnis asperiores tempore,
          neque ad vel porro, fuga pariatur. Omnis recusandae blanditiis vel
          officia suscipit, impedit dicta aperiam minima deserunt reiciendis.
        </p>
        <p>Eserunt in quaerat corrupti eos quibusdam illum vel accusamus:</p>
        <ul>
          <li>Laboriosam velit ducimus aut modi</li>
          <li>Cupiditate debitis</li>
          <li>Velit ducimus aut modi sint aliquam labore</li>
          <li>
            Tenetur quos amet ab exercitationem voluptas omnis asperiores
            tempore, neque ad vel porro, fuga pariatur.
          </li>
        </ul>
        <p>Omnis recusandae vel officia suscipit:</p>
        <ul>
          <li>
            blanditiis voluptatum laboriosam sint praesentium natus ex culpa
            aspernatur
          </li>
          <li>Iusto quos, voluptate similique animi perferendis</li>
          <li>
            voluptates beatae modi doloribus temporibus vel iure optio et sunt
            asperiores
          </li>
        </ul>
        <p>
          Quisquam voluptate similique iste quia vero eos ratione quas
          praesentium dignissimos natus rerum eaque, temporibus quis nisi
          nostrum nobis distinctio officia! Ad consequuntur quidem id ducimus,
          deleniti nihil, porro quibusdam:
        </p>
        <ul>
          <li>
            Et amet voluptas asperiores, ex consequatur delectus dolore quis
            temporibus voluptatibus quas corporis autem.
          </li>
          <li>
            Ad consequuntur, dolor sit amet consectetur adipisicing elit nostrum
            sit dignissimos perspiciatis;
          </li>
          <li>
            Amet incidunt quas minus praesentium commodi eaque soluta vitae
            quaerat labore. Veniam eum, mollitia blanditiis aspernatur unde modi
            iusto. Sapiente dolorem deleniti assumenda, perspiciatis, provident
            ex libero, praesentium corporis ducimus et sunt corrupti veritatis
            quod sed dolor aperiam illo.
          </li>
          <li>
            In unde corrupti expedita quaerat officiis aperiam accusamus, vero
            dolor sunt magnam enim accusantium cum animi modi, alias id officia
            maxime, possimus recusandae quam. Temporibus dolore, blanditiis quo
            sapiente reiciendis aliquam odio.
          </li>
          <li>
            Omnis recusandae blanditiis vel officia suscipit, impedit dicta
            aperiam minima "deserunt reiciendis".
          </li>
        </ul>
        <h3>Doloremque Laudantium</h3>
        <p>
          Et amet voluptas asperiores, ex consequatur delectus dolore quis
          temporibus voluptatibus quas corporis.
          <br />
          Incidunt quas minus praesentium commodi eaque soluta vitae quaerat
          labore. Veniam eum, mollitia blanditiis aspernatur unde modi iusto.
          Sapiente dolorem deleniti assumenda, perspiciatis, provident ex
          libero, praesentium corporis ducimus et sunt corrupti veritatis quod
          sed dolor aperiam illo.
          <br />
          Corrupti expedita quaerat officiis aperiam accusamus, vero dolor sunt
          magnam enim accusantium cum animi modi, alias id officia maxime,
          possimus recusandae quam. Temporibus dolore, blanditiis quo sapiente
          reiciendis odio.
          <br />
          Omnis recusandae blanditiis vel officia suscipit, impedit dicta
          aperiam minima "deserunt reiciendis".
          <br />
          Unde corrupti expedita quaerat officiis aperiam accusamus, vero dolor
          sunt magnam enim accusantium cum animi modi, alias id officia maxime,
          possimus recusandae quam. Temporibus dolore, blanditiis quo sapiente
          reiciendis aliquam odio.
        </p>
        <h3>Temporibus Dolore</h3>
        <p>praesentium corporis ducimus et sunt corrupti:</p>
        <ul>
          <li>
            Vero dolor sunt magnam enim accusantium cum animi modi:
            <ul>
              <li>
                Temporibus dolore blanditiis quo sapiente reiciendis aliquam
                odio.
                <ul>
                  <li>
                    Corporis ducimus et sunt corrupti veritatis quod sed dolor
                    aperiam illo.
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <p>Acctium cum anmi modi:</p>
        <ul>
          <li>Corrupti</li>
          <li>Veritatis quod</li>
          <li>Sunt corri veritatis quod</li>
          <li>Et sunt alias animi</li>
        </ul>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi
          aperiam, magnam dignissimos - atque natus deserunt voluptas. Totam
          cupiditate cumque aut blanditiis. Deleniti quo nulla maxime, esse
          sapiente culpa assumenda consequatur possimus aperiam quis tempore
          officia accusantium rerum. Et, ratione minus?
        </p>
        <h3>Totam Rem Aperiam</h3>
        <p>
          <strong>
            Temporibus dolore, blanditiis quo sapiente reiciendis odio:
          </strong>{" "}
          (1) Lorem ipsum dolor sit; (2) amet consectetur adipisicing elit. Et
          praesentium sapiente, esse beatae; (3) Quae laborum, tempore nisi
          blanditiis in error eos aut repellendus qui adipisci; (4) corrupti
          obcaecati ipsam sapiente provident, accusantium nihil, molestias harum
          inventore aspernatur aliquam cumque; (5) deleniti amet Nihil deserunt
          ratione nulla ipsam odio exercitationem dolor.
        </p>
        <p>
          <strong>Nihil Deserunt</strong>
          <br />
          Corporis, at Voluptas veniam placeat delectus sunt amet! Cum nam
          tenetur delectus et inventore, maiores impedit iusto optio ad. Impedit
          illo adipisci tenetur aliquam. Vitae facere natus praesentium at. In
          nisi itaque omnis magni. Ullam assumenda perferendis voluptates iure
          quaerat illo. Minus quos tenetur saepe reprehenderit fugiat, quia modi
          pariatur asperiores sed.
        </p>
        <p>
          <strong>Nobis Voluptatem</strong>
          <br />
          Quidem sed quam explicabo facere consequatur libero. Sint, corporis
          nihil doloremque, aliquid officiis nobis voluptatem praesentium
          tempore mollitia, quidem qui suscipit ratione sed numquam expedita
          laboriosam quia? Itaque sapiente possimus voluptates repellendus
          quibusdam deserunt dolores facilis assumenda ab, ullam, iste labore
          molestias sint iure sit repellat debitis! Provident doloremque illo
          aliquid quibusdam sapiente deleniti quidem. Assumenda, nam.
        </p>
        <p>
          <strong>Ullam Assumenda</strong>
          <br />
          Dolores facilis assumenda ab ullam, iste labore molestias sint iure
          sit repellat debitis! Provident doloremque illo aliquid quibusdam
          sapiente deleniti quidem. Assumenda, nam.
        </p>
        <p>
          <strong>Vitae-facere Natus</strong>
          <br />
          Harum natus voluptate veritatis inventore, quo ipsum minima dolore
          ratione a modi rerum. Laborum sit, reiciendis maxime dolorem aliquam
          fuga doloribus! Sunt ex recusandae repellat quasi sed libero vel,
          voluptas tempora aut ea quia saepe placeat in dicta eligendi inventore
          odio, ducimus vero accusamus nemo (Distinctio omnis quibusdam ullam.
          Voluptatem sunt maiores, aut error quidem pariatur ipsum eveniet
          delectus molestias saepe quis vel sapiente) soluta deleniti
          doloremque. Dolores ratione odit quae fuga eos debitis minima.
          Voluptatibus corrupti animi fugiat officiis numquam, quaerat placeat
          rem iusto magnam reprehenderit modi. Recusandae voluptatem nihil
          repellat.
        </p>
        <p>
          <strong>Tempora &amp; Consequatur</strong>
          <br />
          Voluptas veniam placeat delectus sunt amet. Cum nam tenetur delectus
          et inventore, maiores impedit iusto optio ad. Impedit illo adipisci
          tenetur aliquam.
          <br />
          Blanditiis consequatur enim fugiat quaerat quis nobis placeat sit.
          Cupiditate officia, ("Eos laboriosam rem"), nihil sunt fugiat
          distinctio quod optio, inventore itaque. Debitis, quod? Vero molestiae
          excepturi beatae tempore non nihil praesentium consequatur error
          tempora iste cupiditate iure, facere dolor incidunt nobis molestias
          quas explicabo est modi reprehenderit omnis voluptatibus quam optio.
          Vero, adipisci quaerat at cum quos ab necessitatibus laboriosam unde
          eius repellat voluptatem alias obcaecati laborum quam numquam
          praesentium nemo sed minima sunt impedit beatae. Fuga ad, amet
          provident incidunt dolore eius vel ducimus sit. Voluptatem laboriosam
          sequi laborum labore eius. Consequuntur autem eius ab, quam
          voluptatibus suscipit excepturi voluptatum nisi, nostrum rem ipsa
          officia, amet adipisci dolores perspiciatis nulla.
          <br />
          Quas explicabo est modi reprehenderit omnis voluptatibus quam optio.
          Vero, adipisci quaerat at cum quos ab necessitatibus laboriosam unde
          eius repellat voluptatem alias obcaecati laborum quam numquam
          praesentium nemo sed minima sunt impedit beatae. Fuga ad, amet
          provident incidunt dolore eius vel ducimus sit.
        </p>
        <p>
          <strong>Amet Adipisci</strong>
          <br />
          Debitis, quod Vero (molestiae excepturi beatae) tempore non nihil
          praesentium consequatur error tempora iste cupiditate iure, facere
          dolor incidunt nobis molestias quas explicabo est modi reprehenderit
          omnis voluptatibus quam optio.
        </p>
        <p>
          <strong>Voluptatem alias obcaecati laborum quam</strong>
          <br />
          Praesentium consequatur error tempora iste cupiditate iure, facere
          dolor incidunt nobis molestias quas explicabo est modi reprehenderit
          (nobis molestias quas explicabo).
          <br />
          Consequuntur autem eius ab, quam dolore voluptatibus Nulla error
          tempore ex veniam alias, (officiis architecto obcaecati aperiam dicta
          ratione facilis labore delectus) explicabo at corporis quo?
          Consequuntur, perferendis.
        </p>
        <p>
          <strong>voluptatem alias quam numquam eaque ipsa</strong>
          <br />
          Adipisci quaerat at cum quos ab necessitatibus laboriosam unde eius
          repellat voluptatem alias obcaecati laborum quam numquam nisi
          praesentium nemo sed minima sunt impedit beatae. Fuga ad, amet nemo
          provident incidunt dolore eius vel ducimus sit. Voluptatem laboriosam
          sequi laborum labore eius. Consequuntur autem eius ab, quam dolore
          voluptatibus suscipit excepturi voluptatum nisi incidunt dolore.
          <br />
          Voluptatem laboriosam sequi laborum labore eius voluptatum nisi
          incidunt (repellat voluptatem alias obcaecati laborum quam numquam
          nisi sed minima), vel praesentium nemo sed minima sunt impedit.
        </p>
        <p>
          <strong>Praesentium Nemo Sed Minima Impedit</strong>
          <br />
          Sunt impedit, amet nemo provident incidunt dolore eius vel ducimus sit
          ducimus <a href="mailto:hr@email.com">hr@email.com</a>.
          <br />
          Fuga ad, amet nemo provident incidunt dolore eius vel ducimus sit.
          Voluptatem laboriosam sequi laborum labore eius. Consequuntur autem
          eius ab, quam dolore voluptatibus suscipit excepturi voluptatum nisi
          incidunt dolore.
        </p>
        <p>
          <strong>Sequi Voluptatem</strong>
          <br />
          Consequuntur autem eius ab, quam dolore voluptatibus suscipit
          excepturi voluptatum <a href="mailto:hr@email.com">hr@email.com</a>.
        </p>
        <p>
          <strong>Dolore Voluptatibus</strong>
          <br />
          Vero, adipisci quaerat at cum quos ab necessitatibus laboriosam unde
          eius repellat voluptatem alias obcaecati laborum quam numquam
          praesentium nemo sed minima quos impedit beatae. Fuga ad, amet
          provident incidunt dolore eius vel sunt.
        </p>
        <p>
          <strong>Tempore Ex Quam Veniam</strong>
          <br />
          Consequuntur autem eius ab, quam dolore voluptatibus Nulla error
          tempore ex veniam, alias, officiis architecto obcaecati aperiam dicta
          ratione facilis labore delectus explicabo at corporis quo?
          Consequuntur, perferendis.
        </p>
        <p>
          <strong>Adipisicing</strong>
          <br />
          Consequuntur autem eius ab voluptatibus suscipit{" "}
          <a href="mailto:hr@email.com">hr@email.com</a>.
        </p>
      </div>
    </FadeIn>
  );
}
